{
  "save": "Guardar",
  "common": {
    "yes": "Sí",
    "no": "No",
    "verify": "Verificar",
    "okay": "Aceptar",
    "accept": "Aceptar",
    "cancel": "Cancelar",
    "notAvailable": "No disponible"
  },
  "generalInfo": {
    "tab": "Información general",
    "tabMobile": "General",
    "srText": "Configuración de la cuenta - Información general",
    "name": {
      "label": "Nombre",
      "pageTitle": "Editar nombre",
      "firstName": "Nombre",
      "firstNameError": "Ingrese su nombre.",
      "lastName": "Apellido",
      "lastNameError": "Ingrese su apellido.",
      "cta": "@:accountSettings.save",
      "successToast": "Nombre actualizado."
    },
    "email": {
      "label": "Correo electrónico",
      "pageTitle": "Editar correo electrónico",
      "cta": "@:accountSettings.save",
      "helperText": "Se enviará un correo de verificación.",
      "successToast": "Correo de verificación fue enviado.",
      "noEmailError": "Ingrese su correo electrónico.",
      "invalidEmailError": "Ingrese un correo electrónico válido.",
      "sameEmailError": "La nueva dirección de correo electrónico debe ser diferente de la actual.",
      "unavailableError": "Esta dirección de correo electrónico ya está en uso.",
      "verify": {
        "successTitle": "Verificación de correo electrónico",
        "emailVerified": "Su dirección de correo electrónico se actualizó correctamente a:",
        "emailVerifiedLogin": "Inicie sesión con el nuevo correo electrónico para comenzar a comunicarse.",
        "signIn": "Iniciar sesión",
        "errorTitle": "Error de verificación",
        "errorMsg": "No se encontró este enlace de activación. Es posible que ese correo electrónico ya se haya verificado o activado."
      },
      "modal": {
        "title": "Verifique su nuevo correo electrónico",
        "lineOne": "Se envió un correo electrónico de verificación a {email}.",
        "lineTwo": "Siga las instrucciones para confirmar su nuevo correo electrónico y luego úselo para iniciar sesión en TalkingParents.",
        "submit": "Aceptar"
      }
    },
    "timezone": {
      "label": "Zona horaria",
      "secondaryLabel": "Formato de fecha",
      "combinedLabel": "Zona horaria/formato de fecha",
      "pageTitle": "Editar zona horaria/formato de fecha",
      "cta": "@:accountSettings.save",
      "successToast": "Zona horaria/formato de fecha actualizado."
    },
    "language": { "label": "Idioma", "en": "English", "es": "Español" },
    "phoneNumber": {
      "label": "Número de teléfono móvil",
      "pageTitle": "Editar número de teléfono móvil",
      "verified": "Verificado",
      "unverified": "No verificado",
      "empty": "No se proporcionó número de teléfono móvil",
      "description": "Su número de teléfono móvil debe verificarse para realizar y recibir llamadas telefónicas grabadas. TalkingParents no comparte esta información con el otro progenitor.",
      "hintText": "Se enviará un código temporal por mensaje de texto.",
      "removeNumberCta": "Eliminar",
      "cta": "Enviar código",
      "removeModal": {
        "button": "Eliminar",
        "title": "Eliminar número de teléfono móvil",
        "content": "Al eliminar el número de teléfono móvil, se desactiva la autenticación multifactor. ¿Desea continuar?",
        "modalCta": "Eliminar número de teléfono",
        "successToast": "Número de teléfono eliminado."
      },
      "modal": {
        "title": "Verificar número de teléfono móvil",
        "description": "Ingrese el código de 6 dígitos enviado a {0} para verificar su número de teléfono.",
        "cta": "@:accountSettings.common.verify",
        "sendAnotherCode": "@:accountSettings.generalInfo.mfa.modal.sendAnotherCode",
        "resentText": "Código de verificación enviado a {phoneNumber}",
        "successVerifyToast": "Número de teléfono verificado.",
        "successUpdateToast": "Número de teléfono actualizado.",
        "errors": {
          "expiredCode": "Este código venció. Intenta de nuevo con un código nuevo.",
          "incorrectCode": "Código de verificación incorrecto. Revisa tu número de teléfono o intenta enviar otro código en 30 segundos.",
          "tooManyAttempts": "Solo puedes enviar un código cada 30 segundos. Intenta de nuevo en 30 segundos.",
          "unexpected": "Ocurrió un error inesperado. Contacta a soporte para obtener ayuda."
        }
      },
      "errors": {
        "invalid": "Ingresa un número de celular válido.",
        "tooManyAttempts": "Demasiados intentos. Intenta más tarde o contacta a soporte para obtener ayuda."
      }
    },
    "mfa": {
      "label": "Autenticación multifactor",
      "enable": "Activar",
      "description": "Proteja su cuenta con autenticación multifactor mediante mensajes de texto.",
      "modal": {
        "title": "Activar autenticación multifactor",
        "description": "Ingrese el código de 6 dígitos enviado a {0}",
        "cta": "Verificar",
        "sendAnotherCode": "Enviar otro código",
        "resentText": "Código de verificación enviado a {phoneNumber}",
        "helpText": "¿No lo encuentra? Visite el {0}",
        "helpCenter": "Centro de ayuda"
      },
      "errors": {
        "phoneNotVerified": "Debes verificar tu número de teléfono antes de activar la autenticación multifactor.",
        "tooManyAttempts": "Demasiados intentos. Intenta más tarde o contacta a soporte para obtener ayuda.",
        "alreadyEnabled": "La autenticación multifactor ya está activada con el número de teléfono asociado a tu cuenta.",
        "alreadyDisabled": "La autenticación multifactor ya está desactivada."
      },
      "enabledToast": "Autenticación multifactor activada.",
      "disabledToast": "Autenticación multifactor desactivada."
    },
    "matchedLabel": "Vinculado",
    "matchedYes": "Sí",
    "matchedNo": "No",
    "coParentLabel": "Otro progenitor",
    "matchedOnLabel": "Vinculado el",
    "accountCreatedLabel": "Cuenta creada"
  },
  "professionals": {
    "tab": "Profesional Vinculado",
    "tabMobile": "Vinculado"
  },
  "planDetails": {
    "tab": "Detalles del plan",
    "tabMobile": "Plan",
    "label": "Tipo de plan",
    "loadingPlan": "Cargando plan...",
    "subscriptionType": {
      "storeSub": "Suscripción {name}",
      "complimentary": "Cortesía",
      "pfcComplimentary": "Plan de cortesía"
    },
    "upgradePlan": "Mejorar plan",
    "upgradeOnly": "Mejorar",
    "switchPlan": "Cambiar plan",
    "managePlan": "Administrar plan",
    "startFreeTrial": "Iniciar prueba gratuita de 30 días",
    "upgradeToStandard": "Mejorar a Standard",
    "upgradeToPremium": "Mejorar a Premium",
    "upgradeTo": "Mejorar a {planName}",
    "tryForFree": "Pruebe {planName} gratis",
    "getPlanForPrice": "Obtenga el {planName} por {planPrice}/mes. Cancele en cualquier momento.",
    "freeTrialForTier": "Gratis durante 30 días para nuevos suscriptores; luego {planPrice}/mes. Cancele en cualquier momento.",
    "seeComparison": "Ver comparación completa de precios",
    "billingInfoHeader": "Información de facturación",
    "billingTypeLabel": "Tipo de facturación",
    "billingTypes": {
      "monthly": "Mensual",
      "annual": "Anual",
      "feeWaiver": "Exención de tarifas",
      "promo": "Promo",
      "pfcPromo": "Promoción de 12 meses"
    },
    "billingNextLabel": "Próxima fecha de facturación",
    "currentPlanExpiresLabel": "Vencimiento del plan actual",
    "expirationDateLabel": "Fecha de vencimiento",
    "promotionExpiresLabel": "La promoción vence el",
    "notAvailable": "No disponible",
    "feeWaiverNotice": "Exención de tarifas aplicada. Vuelve a solicitarla antes de esta fecha para que tu acceso no venza. Para volver a solicitarla, contacta a soporte.",
    "promoNotice": "Oferta promocional aplicada. Tu plan se renovará a la tarifa anual estándar.",
    "pfcPromoNotice": "Oferta promocional aplicada. Cuando el plan venza, deberás volver a suscribirte.",
    "promoPurchasedNotice": "Tu plan actual está activo hasta el {expirationDate}. Tu período promocional comenzará automáticamente cuando venza tu plan actual. Después de 12 meses, tu plan se renueva a la tarifa estándar.",
    "cancel": "Fecha de cancelación",
    "successToast": "Plan actualizado.",
    "tiers": {
      "free": "Gratuito",
      "basic": "Essentials",
      "enhanced": "Enhanced",
      "standard": "Standard",
      "ultimate": "Ultimate",
      "premium": "Premium",
      "unknown": "Desconocido",
      "essentials": "Essentials"
    },
    "planName": {
      "free": "Plan Gratuito",
      "basic": "Plan Essentials",
      "enhanced": "Plan Enhanced",
      "standard": "Plan Standard",
      "ultimate": "Plan Ultimate",
      "premium": "Plan Premium",
      "unknown": "Desconocido"
    },
    "multiSubModal": {
      "title": "Múltiples suscripciones activas",
      "subList": "Tiene múltiples suscripciones activas a través de:",
      "cancelText": "Cancele una de sus suscripciones para evitar cargos duplicados.",
      "tpSub": "Al mantener la suscripción en el sitio web de TalkingParents, se ofrece un mejor soporte para la facturación."
    },
    "existingSubscriptionModal": {
      "title": "Suscripción activa existente",
      "content": "Tu cuenta ya tiene una suscripción activa en TalkingParents. Contacta a soporte para obtener ayuda.",
      "cta": "Aceptar"
    },
    "appleSubModal": {
      "title": "Suscripción de Apple",
      "content": "Su cuenta se actualizó a través de la App Store de Apple. Apple no permite que TalkingParents administre suscripciones ni realice compras dentro de la aplicación. Visite la App Store de Apple para administrar su suscripción o comuníquese con el soporte de Apple.",
      "cta": "Aceptar"
    },
    "androidSubModal": {
      "title": "Suscripción de Google Play",
      "content": "Su cuenta se actualizó a través de Google Play Store. Google no permite que TalkingParents administre suscripciones ni realice compras dentro de la aplicación. Visite la Google Play Store para administrar su suscripción o comuníquese con el soporte de Google.",
      "cta": "Aceptar"
    },
    "premiumConfirmModal": {
      "title": "Aproveche al máximo Premium",
      "content": "Para aprovechar el Plan Premium con Accountable Calling{0}, ambos progenitores deben verificar su número de teléfono y habilitar llamadas telefónicas o de video en la configuración de la cuenta. Estas opciones pueden actualizarse en cualquier momento. Su número telefónico no se comparte con el otro progenitor.",
      "cta": "Entiendo, mejorar mi cuenta",
      "cancelCta": "Cancelar"
    },
    "complimentaryPlanModal": {
      "title": "No se puede modificar el plan",
      "content": "Tiene una promoción aplicada a la cuenta. Para cambiar el plan, contacte a soporte.",
      "cta": "Contactar soporte"
    },
    "promoPurchasedModal": {
      "title": "No se puede modificar el plan",
      "content": "Tiene una promoción aplicada a la cuenta. Para cambiar el plan, contacte a soporte.",
      "cta": "Contactar soporte"
    },
    "subscriptionMigrationModal": {
      "title": "No se puede administrar el plan",
      "content": "Tiene una suscripción programada para cancelarse debido a la migración de nuestro procesador de pagos y no podrá administrar su suscripción hasta que se complete la migración.",
      "cta": "Contactar soporte"
    },
    "card": {
      "perAccount": "Una prueba gratuita de Premium o Standard por cuenta.",
      "currentPlan": "Plan actual",
      "freeTrial": "Prueba gratuita de 30 días",
      "premium": {
        "access": "Acceso al sitio web y a la aplicación móvil",
        "priceTagline": "por suscripción",
        "bullets": [
          "Todas las funciones de Standard y Free, más:",
          "Realice llamadas telefónicas y de video grabadas",
          "Envíe y reciba pagos",
          "120 minutos de llamadas por mes",
          "Acceso a transcripciones y grabaciones de llamadas"
        ]
      },
      "standard": {
        "access": "@:accountSettings.planDetails.card.premium.access",
        "priceTagline": "@:accountSettings.planDetails.card.premium.priceTagline",
        "bullets": [
          "Todas las funciones gratuitas, más:",
          "Acceso a la aplicación móvil",
          "Cree tarjetas de la Biblioteca de Información",
          "Reciba videollamadas grabadas",
          "Reciba mensajes de video",
          "Acceso ilimitado a registros PDF",
          "Almacene y comparta archivos en la Bóveda"
        ]
      },
      "free": {
        "access": "Solo acceso al sitio web",
        "priceTagline": "Sí, es gratis.",
        "bullets": [
          "Envíe y reciba mensajes",
          "Cree eventos de calendario compartido",
          "Reciba pagos",
          "Reciba llamadas telefónicas grabadas",
          "y más... "
        ]
      }
    },
    "freeRecord": {
      "pdfHeader": "Registro PDF gratuito",
      "printedHeader": "Paquete de registros completo",
      "statusLabel": "Estado",
      "statusAvailable": "Disponible",
      "redeemedOnLabel": "Canjeado el",
      "nextAvailableLabel": "Próximo disponible",
      "statusUnavailable": "No disponible"
    },
    "payForCoparent": {
      "cta": "Pagar el plan del otro progenitor",
      "learnMore": "Más información",
      "helpCenter": "@:accountSettings.planDetails.payForCoparent.learnMore",
      "openRedeemModalCta": "El otro progenitor pagó mi plan",
      "pendingEntitlementNotice": "Tu plan actual está activo hasta el {expirationDate}. Tu período promocional comenzará automáticamente cuando venza tu plan actual. Después de 12 meses, deberás volver a suscribirte.",
      "expiresLabel": "Vence",
      "grantedEntitlementNotice": "Tu plan promocional está activo hasta {expirationDate}. Después de 12 meses, tendrás que volver a suscribirte.",
      "redeemSuccessToast": "Plan actualizado correctamente",
      "reviewModal": {
        "title": "Revisa el acceso del otro progenitor",
        "intro": "Confirma los siguientes datos antes de continuar con el pago.",
        "planValue": "{price} por 12 meses",
        "content": "Después del pago, le enviaremos un correo electrónico a {coParentName} con instrucciones para activar su acceso. Tendrá {offerExpirationDays} días para canjear su plan. Tu plan de TalkingParents no cambiará.",
        "cancelCta": "Cancelar",
        "continueCta": "Continuar al pago"
      },
      "redeemModal": {
        "title": "El otro progenitor pagó un año de acceso al plan {tier}.",
        "titleMobile": "El otro progenitor pagó tu plan.",
        "intro": "Para tu cuenta vinculada con {coParentName}.",
        "availableAccess": "Acceso disponible",
        "monthsIncluded": "meses incluidos",
        "content": "No se requiere tarjeta de crédito ni pago. Canjea antes del {expirationDate}. El plan incluye 12 meses de acceso al plan {tier}. Para hacer cambios en este plan, debes contactar a soporte. Al terminar los 12 meses, esta suscripción finalizará y deberás suscribirte a un plan nuevo.",
        "learnMore": "@:accountSettings.planDetails.payForCoparent.learnMore",
        "redeemCta": "Canjear plan"
      },
      "confirmModal": {
        "title": "Confirma tu nuevo plan",
        "content": "Estás a punto de comenzar 12 meses del plan {tier}, pagados por el otro progenitor. No podrás hacer cambios en tu suscripción una vez que esté activa.",
        "scheduledContent": "No podrás hacer cambios en tu plan una vez que esté activo. Visita nuestro Centro de ayuda para obtener más información sobre cómo canjear un plan pagado por el otro progenitor.",
        "goBack": "Volver",
        "confirmCta": "Confirmar plan",
        "learnMore": "@:accountSettings.planDetails.payForCoparent.learnMore",
        "contactSupport": "Contactar a soporte"
      },
      "activePlanModal": {
        "title": "Ya tienes un plan activo",
        "intro": "Puedes canjear este plan una vez que canceles tu plan actual.",
        "content": "Tu nuevo plan se activará cuando venza tu plan anterior. Si tienes otro plan promocional o de cortesía y quieres hacer cambios en tu suscripción, deberás contactar a soporte. Si te suscribiste a través de otra tienda de aplicaciones, como Apple o Google Play, deberás cancelar desde esa tienda.",
        "managePlan": "Administrar plan",
        "learnMore": "@:accountSettings.planDetails.payForCoparent.learnMore",
        "contactSupport": "Contactar a soporte"
      },
      "success": {
        "title": "Compra exitosa",
        "content": "Gracias por tu compra. El otro progenitor recibirá un correo electrónico con instrucciones para activar su suscripción.",
        "cta": "Listo"
      },
      "error": {
        "content": "Hay un problema con tu patrocinio. Contacta a soporte.",
        "entitlementTimeoutContent": "La actualización de tu plan está tardando más de lo esperado. Vuelve a revisar en unos minutos. Si tu plan aún no se ha actualizado, contacta a soporte."
      }
    },
    "paywall": {
      "header": "Administrar plan",
      "fullPricePlans": "Planes a precio regular",
      "promoBanner": "{important}: Hay una promoción aplicada a su cuenta. Para realizar cambios, {contactSupport}.",
      "promoBannerImportant": "Importante",
      "promoBannerContactSupport": "contacte a soporte",
      "tableHeader": {
        "monthly": "Mensual",
        "annual": "Anual",
        "save": "(Ahorre 16%)"
      },
      "free": {
        "header": "Gratuito",
        "subHeader": "",
        "webOnly": "Solo web",
        "bullets": [
          "Mensajería segura con anuncios",
          "Calendario compartido",
          "Diario personal",
          "Reciba llamadas telefónicas grabadas",
          "Con anuncios",
          "Acceso básico a la mayoría de las funciones",
          "Requiere compras dentro de la aplicación"
        ],
        "monthlyPrice": "0",
        "annualPrice": "0",
        "savingsMonthly": "",
        "savingsAnnual": ""
      },
      "currency": "$",
      "usd": "USD",
      "perMonth": "por mes",
      "perYear": "por año",
      "upgradePlan": "Mejorar plan",
      "currentPlan": "Plan actual",
      "managePlan": "Administrar plan",
      "essentials": {
        "header": "Essentials",
        "subHeader": "Mensajería, Calendario, más:",
        "bullets": [
          "{minutes} minutos de llamadas",
          "1 GB de almacenamiento en la Bóveda"
        ],
        "monthlyPrice": "6",
        "annualPrice": "60",
        "savingsMonthly": "Ahorre {currency}12 con planes anuales",
        "savingsAnnual": "Ahorre anualmente {currency}12"
      },
      "enhanced": {
        "header": "Enhanced",
        "subHeader": "Incluye todas las funciones de Essentials, más:",
        "bullets": [
          "{minutes} minutos de llamadas",
          "Registros PDF ilimitados",
          "15 GB de almacenamiento en la Bóveda"
        ],
        "monthlyPrice": "12",
        "annualPrice": "120",
        "savingsMonthly": "Ahorre {currency}24 con planes anuales",
        "savingsAnnual": "Ahorre anualmente {currency}"
      },
      "ultimate": {
        "header": "Ultimate",
        "subHeader": "Todas las funciones de Enhanced, además:",
        "bullets": [
          "Minutos de llamadas ilimitados",
          "Herramientas IA Sentiment Scanner + Writing Assist℠",
          "Soporte prioritario",
          "Pago exprés",
          "50 GB de almacenamiento en la Bóveda"
        ],
        "monthlyPrice": "27",
        "annualPrice": "270",
        "savingsMonthly": "Ahorre {currency}54 con planes anuales",
        "savingsAnnual": "Ahorre anualmente {currency}54"
      },
      "seeFullPricingPlan": "¿Necesita ayuda para decidir? Consulte el {pricingPlan} completo.",
      "pricingPlan": "plan de precios",
      "promo": {
        "titlePrice1": "[Promo Card Title If The Title Is Long ]",
        "bullet1Price1": "Acceso completo al plan {tier}",
        "bullet2Price1": "12 meses facturados {upfront}",
        "bullet2UpfrontPrice1": "por adelantado",
        "bullet3Price1": "Sin interrupción en {yourAccount}",
        "bullet3YourAccountPrice1": "su cuenta",
        "titlePrice2": "[Second promo]",
        "bullet1Price2": "[Foo]",
        "bullet2Price2": "[Bar]",
        "bullet3Price2": "[Baz]",
        "cta": "Obtener oferta de 12 meses",
        "disclaimer": "Se renueva al precio estándar después del período promocional"
      },
      "discountedOfferTitle": "Oferta con descuento",
      "limitedTimeOfferLabel": "Oferta por tiempo limitado",
      "limitedTimeOfferDetailFree": "Oferta disponible hasta el 1 de junio de 2026. Pago por adelantado como un cargo único por 12 meses. Después de 12 meses, el plan se renueva a la tarifa anual estándar.",
      "limitedTimeOfferDetailPaid": "Oferta disponible hasta el 1 de junio de 2026. El periodo promocional comienza una vez que expire el plan actual. Pago por adelantado como un cargo único por 12 meses. Después de 12 meses, el plan se renueva a la tarifa anual estándar.",
      "fullPricePlansLabel": "Planes a precio regular",
      "promoCard": {
        "cta": "Asegurar mi oferta",
        "planOnly": "Plan {planName}",
        "planForPrice": "Plan {planName} por {price}",
        "discountAvailable": "Descuento disponible para el plan {planName}",
        "discounts": {
          "price1": {
            "essentials": "16 % de descuento en el precio mensual de Essentials / 9 % de descuento en el precio anual de Essentials",
            "enhanced": "16 % de descuento en el precio mensual de Enhanced / 9 % de descuento en el precio anual de Enhanced",
            "ultimate": "16 % de descuento en el precio mensual de Ultimate / 9 % de descuento en el precio anual de Ultimate"
          },
          "price2": {
            "essentials": "14 % de descuento en el precio mensual de Essentials / 6 % de descuento en el precio anual de Essentials",
            "enhanced": "25 % de descuento en el precio mensual de Enhanced / 18 % de descuento en el precio anual de Enhanced",
            "ultimate": "15 % de descuento en el precio mensual de Ultimate / 7 % de descuento en el precio anual de Ultimate"
          }
        }
      }
    },
    "duplicateSubscriptionModal": {
      "title": "Suscripción activa existente",
      "content": "Tu cuenta ya tiene una suscripción activa en TalkingParents. Contacta a soporte para obtener ayuda."
    },
    "promotionExpiresOnLabel": "La promoción vence el",
    "newPlanStartsLabel": "Inicio del nuevo plan",
    "promoPurchasedExplanation": "Tu plan actual está activo hasta el {date}. Tu período promocional comenzará automáticamente cuando venza tu plan actual. Después de 12 meses, tu plan se renueva a la tarifa estándar."
  },
  "calling": { "tab": "Llamadas documentadas", "tabMobile": "Llamadas" },
  "notifications": {
    "tab": "Notificaciones",
    "email": {
      "label": "Notificaciones por correo electrónico",
      "description": "Reciba un correo electrónico cuando haya un nuevo mensaje, evento de calendario o tarjeta de la Biblioteca de información.",
      "disabledSuccessToast": "Notificaciones por correo electrónico desactivadas.",
      "enabledSuccessToast": "Notificaciones por correo electrónico activadas."
    },
    "text": {
      "label": "Notificaciones por mensaje de texto",
      "description": "Reciba notificaciones por mensaje de texto sobre nuevos mensajes.",
      "remainingBalance": "Saldo restante",
      "disabledSuccessToast": "Notificaciones por mensaje de texto desactivadas.",
      "enabledSuccessToast": "Notificaciones por mensaje de texto activadas.",
      "disableModal": {
        "title": "Desactivar notificaciones por mensaje de texto",
        "content": "Confirme que desea desactivar las notificaciones por mensaje de texto y reembolsar el saldo prepagado restante.",
        "confirmCta": "Aceptar",
        "cancelCta": "Cancelar"
      },
      "unverifiedModal": {
        "title": "Número no verificado",
        "content": "Verifique su número de teléfono móvil antes de activar las notificaciones por mensaje de texto.",
        "confirmCta": "Aceptar"
      },
      "enterVerificationCode": "Ingrese el código de verificación",
      "enableTitle": "Activar notificaciones por mensaje de texto",
      "checkoutRedirectError": "Hubo un error al redirigirte a la página de pago. Intenta de nuevo."
    },
    "newsletter": {
      "label": "Boletines por correo electrónico",
      "description": "Manténgase informado con las últimas actualizaciones y recursos para la crianza.",
      "cta": "Editar preferencias"
    }
  },
  "password": {
    "tab": "Contraseña",
    "srText": "Configuración de la cuenta - Actualizar contraseña",
    "current": {
      "label": "Contraseña actual",
      "emptyError": "Requiere la contraseña actual.",
      "incorrectError": "La contraseña actual es incorrecta."
    },
    "new": {
      "label": "Nueva contraseña",
      "emptyError": "Se requiere una nueva contraseña.",
      "requirementsError": "La contraseña no cumple los requisitos.",
      "sameError": "La nueva contraseña no puede ser igual a la actual."
    },
    "confirm": {
      "label": "Confirmar nueva contraseña",
      "emptyError": "Confirme la nueva contraseña.",
      "noMatchError": "Las contraseñas no coinciden."
    },
    "successToast": "Contraseña actualizada.",
    "update": "Actualizar"
  },
  "links": {
    "tos": "Términos de servicio",
    "privacyPolicy": "Política de privacidad"
  },
  "messaging": {
    "tab": "Mensajería segura",
    "tabMobile": "Mensajería",
    "toggle": {
      "label": "Sugerir eventos de calendario",
      "description": "Cree automáticamente eventos a partir de mensajes para revisarlos y agregarlos al calendario compartido."
    },
    "sentimentToggle": {
      "label": "Mostrar sentimiento (Privado)",
      "description": "Muestra la puntuación de sentimiento de los mensajes analizados. Solo es visible para usted y no aparecerá en el registro."
    },
    "paymentRequestToggle": {
      "label": "Sugerir solicitudes de pago",
      "description": "Permita que el sistema detecte y sugiera solicitudes de pago (Accountable Payments) a partir de los mensajes.",
      "enabled": "Solicitudes de pago sugeridas activadas.",
      "disabled": "Solicitudes de pago sugeridas desactivadas."
    },
    "errors": {
      "updatePaymentRequestSuggestions": "No se pudo actualizar la configuración de solicitudes de pago sugeridas.",
      "updateSentiment": "Ocurrió un error: {error}"
    }
  },
  "calendar": {
    "tab": "Calendario compartido",
    "tabMobile": "Calendario",
    "header": "Conectar al calendario personal",
    "description": "Agregue automáticamente los eventos del calendario compartido a su calendario personal. Solo se agregan los eventos visualizados. Los cambios realizados en su calendario personal no se reflejarán en TalkingParents.",
    "learnMore": "Más información",
    "provider": {
      "connectCta": "Conectar",
      "disconnected": "Calendario desconectado. Seleccione para reconectar.",
      "deleted": "Calendario eliminado. Seleccione para reconectar.",
      "updated": "Última actualización {datetime}",
      "toast": {
        "connected": "{providerName} conectado.",
        "successTitle": "Conexión exitosa"
      },
      "modal": {
        "connect": {
          "header": "\"TalkingParents\" quiere usar \"{providerName}\" para iniciar sesión",
          "content": "TalkingParents necesita permiso para agregar eventos del calendario compartido a su calendario personal.",
          "confirmCta": "Continuar",
          "cancelCta": "Cancelar"
        },
        "trash": {
          "header": "¿Eliminar calendario conectado?",
          "content": "Se eliminará el acceso al calendario personal y no se agregarán nuevos eventos del calendario compartido.",
          "confirmCta": "Continuar",
          "cancelCta": "Cancelar"
        },
        "scopes": {
          "header": "Permisos requeridos",
          "content": "Otorgue todos los permisos solicitados. Intente nuevamente y acepte ambas solicitudes de permiso. Visite el Centro de ayuda para más información.",
          "confirmCta": "Intentar de nuevo",
          "cancelCta": "Cancelar"
        },
        "disconnected": {
          "header": "Calendario desconectado",
          "content": "TalkingParents ya no está conectado a su calendario personal. Los nuevos eventos no se agregarán hasta que vuelva a conectar.",
          "confirmCta": "Reconectar",
          "cancelCta": "Ahora no"
        },
        "deleted": {
          "header": "Calendario eliminado",
          "content": "TalkingParents se eliminó de su calendario personal. Visite el Centro de ayuda para soluciones y pasos de resolución de problemas.",
          "confirmCta": "Centro de ayuda",
          "cancelCta": "Ahora no"
        },
        "connectIssue": {
          "header": "Problema de conexión del calendario",
          "content": "TalkingParents no puede conectarse a su calendario personal. Visite el Centro de ayuda para soluciones y pasos de resolución de problemas.",
          "confirmCta": "Centro de ayuda",
          "cancelCta": "Descartar"
        }
      },
      "errors": {
        "initializeGoogleAuth": "No se pudo iniciar la autenticación con Google.",
        "connectGoogle": "TalkingParents no pudo conectarse a Google.",
        "manualSync": "No se pudo sincronizar el calendario manualmente.",
        "disconnect": "No se pudo desconectar el calendario."
      }
    }
  },
  "appearance": { "tab": "Apariencia", "srText": "Apariencia" },
  "minutesPlan": {
    "minutes": "Minutos",
    "selected": "Seleccionado",
    "select": "Seleccionar"
  }
}
